export enum RequestTypes {
  PartialDay = 0,
  SingleDay = 1,
  MultipleDays = 2
}

export interface TimeOffRequestList {
  Pending: PendingTimeOffRequest[];
  Approved: TimeOffRecord[];
  Deleted: TimeOffRecord[];
  EditedTimeOffRecords: EditedRecord[];
}

export interface PayrollTimeOffRecord {
  EarningId: string;
  PersonId: number;
  Days: PayrollTimeOffDay[];
}

export interface PayrollTimeOffDay {
  Date: Date;
  Hours: number;
}

export interface PendingTimeOffRequest {
  RequestId: number;
  Open: boolean;
  Pending: boolean;
  Approved: boolean;
  Declined: boolean;
  EditedByRequester: boolean;
  EditedByApprover: boolean;
  Request: TimeOffRequest;
  PreviousRequest: TimeOffRequest | null;
  RequesterName: string;
  DateRequested: Date;
  PersonId: number;
}

export interface ClientTimeOffRequest extends TimeOffRequest {
  PersonId: number;
}

export interface TimeOffRequest {
  ClientComments: string | null;
  TimeOffType: number;
  TimeOffTypeName: string;
  TimeOffRequestType: RequestTypes;
  StartDate: Date | null;
  Hours: number | null;
  EmployeeComments: string | null;
  StartTime: Date | null;
  EndTime: Date | null;
  DateRange: TimeOffDateRange | null;
}

export interface TimeOffDateRange {
  Start: Date;
  End: Date;
}

export interface Balances {
  PlanId: number;
  Approved: number;
  Used: number;
  Accrued: number;
  Balance: number;
}

export interface TimeOffDay {
  Id: number;
  Date: Date | string;
  Hours: number;
  TimeOffRequestId: number;
}

export interface EditedRecord {
  OriginalRecord: TimeOffRecord;
  EditedRecord: TimeOffRecord;
  Request: any;
  ClientComments: string;
}
export interface TimeOffRecord {
  Id: number;
  ClientCode: string;
  PersonId: number;
  PersonName: string;
  PlanId: number;
  PlanName: string;
  RequestType: RequestTypes;
  StartDate: Date | string;
  EndDate: Date | string;
  DateApproved: Date | string;
  AERequestId: number;
  TimeOffDays: TimeOffDay[];
  Comments: string;
  EmployeeComments: string;
  Removed: boolean;
  HasPayroll: boolean;
}
